<div class="main row">
  <div class="column twelve sm-ten sm-push-one md-eight md-push-two lg-six lg-push-three">
    <router-outlet></router-outlet>
  </div>
</div>
